import NextHead from '@/components/NextHead';
import { ArticleContainer, ContentPageWrapper, MainImage } from '@/pages/ContentPage/styled';
import metas from '@/routes/meta';
import { bffService } from '@thisisdevelopment/akzonobel-core';
import { Page, Wysiwyg } from '@thisisdevelopment/heritage-core-library';
import { GetStaticProps } from 'next';
import { useTheme } from 'styled-components';
import { pageRevalidate } from '../../../src/config';

type ContentPageType = {
  id: number;
  status: string;
  slug: string;
  title: string;
  prefix?: string;
  body: string;
  image?: number;
  meta_title?: string;
  meta_description?: string;
  meta_keywords?: string;
};

type SSRProps = {
  page: ContentPageType;
};

const categoryName = 'content_pages';

const ContentPage = ({ page }: SSRProps) => {
  const theme = useTheme();

  if (page) {
    const meta = {
      title: page.meta_title || metas.default.title,
      description: page.meta_description || metas.default.description,
      keywords: page.meta_keywords || metas.default.keywords,
    };

    return (
      <div>
        <NextHead meta={meta} />
        <ContentPageWrapper>
          <Page
            title={page.title}
            prefix={page.prefix}
            prefixColor={theme.colors.brandGold}
            color={theme.colors.brandBlueDark}
            bgColor={theme.colors.white}
          >
            {page.image && <MainImage id={page.image} alt="Hero Image" />}
            <ArticleContainer>
              <Wysiwyg content={page.body} />
            </ArticleContainer>
          </Page>
        </ContentPageWrapper>
      </div>
    );
  }

  return null;
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const page = (await bffService
    .getCmsItemBySlug(categoryName, params?.slug as string)
    .then((r) => r.data.data)
    .catch(() => null)) as ContentPageType;

  if (!page) {
    return { notFound: true };
  }

  return {
    props: { page },
    revalidate: pageRevalidate,
  };
};

export async function getStaticPaths() {
  const pages = (await bffService
    .getCmsItem(categoryName)
    .then((r) => r.data.data)
    .catch(() => [])) as ContentPageType[];

  const paths = pages.map((p) => ({
    params: { slug: p.slug },
  }));

  return {
    paths,
    fallback: 'blocking',
  };
}

export default ContentPage;
